"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    palette: palette,
    background: palette.elPrimary,
    padding: palette.gutter * 2,
    boxShadow: "0 2px 4px 0 ".concat(palette.elShadowLight, ", 0 0 4px 0 ").concat(palette.elShadowLight),
    borderRadius: '3px',
    transition: "box-shadow ".concat(palette.transitionDuration, " ").concat(palette.transitionFunction),
    hoverBoxShadow: "0 4px 8px 0 ".concat(palette.elShadow, ", 0 2px 8px 0 ").concat(palette.elShadow)
  };
}